
import constants from '@/constants';
import { celciusToFahrenheit } from '@/common/functions';

// Build a mapping from parameter code to Variable
let parameterCdToVariableName: Record<string, any> = {};
Object.keys(constants.FlowVariables).forEach((key) => {
  let value = constants.FlowVariables[key];
  parameterCdToVariableName[value.parameterCd] = key;
});

Object.keys(constants.SecondaryVariables).forEach((key) => {
  let value = constants.SecondaryVariables[key];
  parameterCdToVariableName[value.parameterCd] = key;
});

function isFlowVariable(variableName: string) {
  return Object.keys(constants.FlowVariables).indexOf(variableName) !== -1;
}

function isSecondaryVariable(variableName: string) {
  return Object.keys(constants.SecondaryVariables).indexOf(variableName) !== -1;
}

/**
 * OSF API client USGS Historical Data wrapper
 *
 * Definitely needs refactoring at some point. Consider moving most functionality to functions,
 * or moving some logic to SiteData.
 */
export default class {
  timePeriod: String;
  flowVariables: Record<string, any> = {};
  secondaryVariables: Record<string, any> = {};

  constructor(timePeriod: String, rawData: Array<object>) {
    this.timePeriod = timePeriod;
    this.flowVariables       = {};
    this.secondaryVariables  = {};

    this.setVariables(rawData);
  }

  setVariables(rawData: any) {

    rawData.value.timeSeries.forEach((series: any) => {
      let parameterCd           = series.variable.variableCode[0].value;
      let variableName: string  = parameterCdToVariableName[parameterCd];
      let rawTimeSeries         = series.values[0].value;

      // TODO handle missing data...
      // Conditions where data points are missing...
      // - full - rawTimeSeries is an empty array
      // --> print "No Data Available" over graph
      // - partial - rawTimeSeries
      // --> stitch "no data available" into graph at same cadence as data that's present

      // Conditions where data points are invalid
      // - -999999 - value for invalid data

      let timeSeries            = rawTimeSeries.map((timeSeriesDatum: any) => {
        let value = timeSeriesDatum.value;

        return {
          x : new Date(timeSeriesDatum.dateTime),
          y : value,
          qualifiers: timeSeriesDatum.qualifiers
        }
      });

      // Convert water temp to degrees fahrenheit
      if (parameterCd === constants.SecondaryVariables.WaterTemp.parameterCd) {
        timeSeries = timeSeries.map((timeSeriesDatum: any) => {
          return {
            x: timeSeriesDatum.x,
            y: celciusToFahrenheit(timeSeriesDatum.y).toFixed(2)
          }
        })
      }

      if (isFlowVariable(variableName)) {
        this.flowVariables[variableName] = timeSeries;
      } else if (isSecondaryVariable(variableName)) {
        this.secondaryVariables[variableName] = timeSeries;
      }
    });
  }
};
